module.exports = __webpack_public_path__ + "img/rectangle-portrait.svg";